var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[(_vm.roleid != 5)?_c('sidebar-fixed-toggle-button'):_vm._e(),(_vm.roleid != 5)?_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.$t('sidebar.title')}},[_c('template',{slot:"links"},[(_vm.isLand)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.landoverview'),
          img: require('../../assets/img/eprf-home.png'),
          path: '/Land/Overview',
        }}}):_vm._e(),(_vm.isVessel)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vesseloverview'),
          img: require('../../assets/img/eprf-home.png'),
          path: '/Vessel/Overview',
        }}}):_vm._e(),(_vm.isVendor)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vendoroverview'),
          img: require('../../assets/img/eprf-home.png'),
          path: '/Vendor/Overview',
        }}}):_vm._e(),(_vm.isAuthorities)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.authoritiesoverview'),
          img: require('../../assets/img/eprf-home.png'),
          path: '/Authorities/Overview',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.overview'),
          img: require('../../assets/img/eprf-home.png'),
          path: '/overview',
        }}}):_vm._e(),(_vm.isAdmin && _vm.position != 'OPERATION' 
        // && position != 'MANAGEMENT'
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.adminusers'),
          img: require('../../assets/img/eprf-users.png'),
          path: '/Users',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.adminhome'),
          img: require('../../assets/img/Home-incoming copy.png'),
          path: '/Incoming',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.adminpre-process'),
          img: require('../../assets/img/eprf-ship.png'),
          path: '/Preprocess',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.admininventory'),
          img: require('../../assets/img/eprf-inventory.png'),
          path: '/Inventory',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.adminoutgoing'),
          img: require('../../assets/img/eprf-lorry.png'),
          path: '/Outgoing',
        }}}):_vm._e(),(_vm.isLand)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.landjob'),
          img: require('../../assets/img/eprf-lorry.png'),
          path: '/Land/Request',
        }}}):_vm._e(),(_vm.isVessel)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vesseljob'),
          img: require('../../assets/img/eprf-lorry.png'),
          path: '/Vessel/Request',
        }}}):_vm._e(),(_vm.isVendor)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vendorjob'),
          img: require('../../assets/img/eprf-lorry.png'),
          path: '/Vendor/Job',
        }}}):_vm._e(),(_vm.isAuthorities)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.authoritiesjob'),
          img: require('../../assets/img/eprf-lorry.png'),
          path: '/Authorities/Job',
        }}}):_vm._e(),(_vm.isLand)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.browse'),
          img: require('../../assets/img/cart.png'),
          path: '/Land/Sales',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.sales'),
          img: require('../../assets/img/cart.png'),
          path: '/Sales',
        }}}):_vm._e(),(_vm.isVessel)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.browse'),
          img: require('../../assets/img/cart.png'),
          path: '/Vessel/Sales',
        }}}):_vm._e(),(_vm.roleid == 1)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('Authority'),
          img: require('../../assets/img/authority.png'),
          path: '/Authorities/Overview',
        }}}):_vm._e(),(_vm.isLand)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.landcalendar'),
          img: require('../../assets/img/eprf-calendar.png'),
          path: '/Land/Calendar',
        }}}):_vm._e(),(_vm.isVessel)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vesselcalendar'),
          img: require('../../assets/img/eprf-calendar.png'),
          path: '/Vessel/Calendar',
        }}}):_vm._e(),(_vm.isVendor)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.vendorschedule'),
          img: require('../../assets/img/eprf-calendar.png'),
          path: '/Vendor/Schedule',
        }}}):_vm._e(),(_vm.isAuthorities)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.authoritiesschedule'),
          img: require('../../assets/img/eprf-calendar.png'),
          path: '/Authorities/Schedule',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.admincalendar'),
          img: require('../../assets/img/eprf-calendar.png'),
          path: '/Calendar',
        }}}):_vm._e(),(_vm.roleid == 1)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.adminform'),
          img: require('../../assets/img/eprf-forms.png'),
          path: '/Forms',
        }}}):_vm._e()],1)],2):_vm._e(),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }